<template lang="pug">
  v-card
    v-card-title
      h2.card-title Редагувати модель
    v-card-content
      v-text-field(
        :focus="true"
        label="Назва моделі"
        v-model="form.name"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
      )
    v-card-actions
      v-btn.mr-2(
        @click="onSave"
        :loading="loading"
      ) {{ 'base.save' | translate }}
      delete-btn(
        @delete="onDelete"
      )
</template>

<script>
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'EditModelModal',
  components: { DeleteBtn },

  props: {
    selected: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [formErrorsMixin],
  data: () => ({
    form: {},
    errors: {
      name: null
    },
    loading: false
  }),

  mounted () {
    this.form = { ...this.selected }
  },

  methods: {
    async onSave () {
      this.loading = true
      this.checkValidData()

      if (this.errors.name === null) {
        const updatedData = { ...this.form }

        this.$emit('update', updatedData)
        this.$emit('close')
      }

      this.loading = false
    },
    checkValidData () {
      this.errors.name = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    },
    async onDelete () {
      this.$emit('delete', this.form.id)
      this.$emit('close')
    }
  }
}
</script>